/* API Context */
import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de l'utilisateur.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getUser = (token, id) => {
    const url = `/api-v1/user/${id}/profile`
    return getRequest(url, token)
}

/**
 * Mise à jour des informations de l'utilisateur.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateUserProfile = (token, body) => {
    const url = `/api-v1/user/profile/update`
    return postRequest(url, body, token)
};